type Data = { link: string; label: string }

const icon =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.569 6.39509 13.9269 6.25143 12.8271 7.17675L11.39 8.38588C10.0935 9.47674 9.95704 11.4241 11.0887 12.6852L11.12 12.72"></path></svg>'

export class Link {
    data: Data
    wrapper: HTMLElement
    anchor: HTMLAnchorElement
    readOnly: boolean
    settings: Array<{ name: string; label: string; icon: string }>
    editMode: boolean

    static get toolbox() {
        return {
            title: 'Link',
            icon,
        }
    }

    static get isReadOnlySupported() {
        return true
    }

    constructor({ data, readOnly }: { data: Data; readOnly: boolean }) {
        this.data = data
        this.wrapper = undefined
        this.anchor = undefined
        this.readOnly = readOnly
        this.editMode = !readOnly
        this.settings = [
            {
                name: 'edit',
                label: 'Vorschau',
                icon,
            },
        ]
    }

    _handleInput() {
        if (this.readOnly) return
        if (!this.anchor) {
            this.anchor = document.createElement('a')
            this.wrapper.appendChild(this.anchor)
        }
        if (this.data.label && this.data.link) {
            this.anchor.text = this.data.label
            this.anchor.href = this.data.link
        }

        // TODO: hide inputs after 5s inactivity?
    }

    _handleSettings(name: string) {
        if (name === 'edit') {
            this._toggleEditMode()
        }
    }

    _toggleEditMode() {
        this.editMode = !this.editMode
        this.wrapper.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('not-shown')
            input.disabled = !this.editMode
        })
    }

    render(): HTMLElement {
        this.wrapper = document.createElement('div')
        this.wrapper.classList.add('custom-link-wrapper')

        if (this.data.link && this.data.label) {
            this.anchor = document.createElement('a')
            this.wrapper.appendChild(this.anchor)
            this.anchor.text = this.data.label
            this.anchor.href = this.data.link

            if (this.editMode) {
                this.anchor.style.cursor = 'default'
                this.anchor.style.pointerEvents = 'none'
            }
        }

        if (!this.readOnly && this.editMode) {
            const linkInput = document.createElement('input')
            const labelInput = document.createElement('input')

            linkInput.type = 'text'
            linkInput.placeholder = 'Link'
            linkInput.value = this.data && this.data.link ? this.data.link : ''
            linkInput.addEventListener('input', () => {
                this.data.link = linkInput.value
                this._handleInput()
            })

            labelInput.type = 'text'
            labelInput.placeholder = 'Label'
            labelInput.value = this.data && this.data.label ? this.data.label : ''
            labelInput.addEventListener('input', () => {
                this.data.label = labelInput.value
                this._handleInput()
            })

            this.wrapper.appendChild(linkInput)
            this.wrapper.appendChild(labelInput)
        }

        return this.wrapper
    }

    renderSettings(): HTMLElement {
        const wrapper = document.createElement('div')

        this.settings.forEach((tune) => {
            const button = document.createElement('div')
            const label = document.createElement('span')
            const iconWrapper = document.createElement('div')

            iconWrapper.innerHTML = tune.icon
            iconWrapper.classList.add('custom-link-settings-icon')

            button.classList.add('cdx-settings-button')
            button.style.width = '100%'
            button.appendChild(iconWrapper)
            button.appendChild(label)

            label.textContent = tune.label
            label.classList.add('ce-popover-item__title')
            wrapper.appendChild(button)

            button.addEventListener('click', () => {
                this._handleSettings(tune.name)
                button.classList.toggle('cdx-settings-button--active')
            })
        })

        return wrapper
    }

    save(blockContent: HTMLElement): Data {
        return {
            link: blockContent.querySelector('a')?.href,
            label: blockContent.querySelector('a')?.innerText,
        }
    }

    validate(savedData: Data): boolean {
        return !(!savedData.link?.trim() || !savedData.label?.trim())
    }
}
